import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Fragment as _Fragment, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ContecLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-7e4d406c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "logined_panel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "Contec_Logo"
}, null, -1))
const _hoisted_3 = { class: "logined_panel_fixation_area" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "setellite_name" }, " OREUM SAT ", -1))
const _hoisted_7 = { class: "logined_panel_contents_area" }
const _hoisted_8 = { class: "location" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " LAT ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " LON ", -1))
const _hoisted_11 = { class: "country_name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';

import AccountInfo from '@/components/common/AccountInfo.vue';
import EditPassword from '@/components/common/EditPassword.vue';
import IconButtons from '@/components/desktop/IconButtons.vue';
import DownwardsArrowSvg from '@/assets/images/Svgs/DownwardsArrowSvg.vue';
import useCommonStore from '@/store/storeCommon';
import useMapStore from '@/store/storeMap';
import useMemberStore from '@/store/storeMember';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginedPanel',
  setup(__props) {

const { isImageMode } = storeToRefs(useCommonStore());
const { disabledQualification, showPanel } = useCommonStore();
const { accessedMemberInfo, getLevelImageSrc, getLevelName } = useMemberStore();
const { getCoordinate, satelliteInfo } = useMapStore();

/**
 * 실시간 지역 이름을 가져옵니다.
 */
const getCountryName = computed((): string => {
  return satelliteInfo.locationName === ''
    ? '찾는중'
    : `In ${satelliteInfo.locationName}`;
});

onMounted(() => {
  showPanel.isAccountInfo = true;
});

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showLoginedPanel':
      return !!(accessedMemberInfo.name && !isImageMode.value);
    case 'showAccountInfo':
      return showPanel.isAccountInfo && !showPanel.isEditPassword;
    case 'showEditPassword':
      return showPanel.isAccountInfo && showPanel.isEditPassword;
    default:
      return false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (qualificationFunction('showLoginedPanel'))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(showPanel).isLeftPanel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["logined_panel_inner", {'opacity': _unref(disabledQualification)()}])
                  }, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("img", {
                        class: "side_logo",
                        src: _unref(getLevelImageSrc)(_unref(accessedMemberInfo).level,'SideLogo'),
                        alt: "side logo"
                      }, null, 8, _hoisted_4),
                      _createElementVNode("img", {
                        class: "character",
                        src: _unref(getLevelImageSrc)(_unref(accessedMemberInfo).level,''),
                        alt: `${_unref(accessedMemberInfo).level}`
                      }, null, 8, _hoisted_5),
                      _createElementVNode("h2", {
                        class: _normalizeClass(["character_name", _unref(getLevelName)()])
                      }, _toDisplayString(_unref(getLevelName)()), 3),
                      _hoisted_6
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_TransitionGroup, {
                        name: "slide",
                        tag: "div",
                        class: "contents"
                      }, {
                        default: _withCtx(() => [
                          (qualificationFunction('showAccountInfo'))
                            ? (_openBlock(), _createBlock(AccountInfo, { key: 0 }))
                            : _createCommentVNode("", true),
                          (!_unref(showPanel).isAccountInfo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(_unref(getLevelName)())
                              }, [
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("h4", null, [
                                    _hoisted_9,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(_unref(getCoordinate)("Lat")), 1),
                                    _createTextVNode("N ")
                                  ]),
                                  _createElementVNode("h4", null, [
                                    _hoisted_10,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(_unref(getCoordinate)("Lon")), 1),
                                    _createTextVNode("E ")
                                  ])
                                ]),
                                _createVNode(DownwardsArrowSvg, { class: "downwards_arrow" }),
                                _createElementVNode("h4", _hoisted_11, [
                                  _createTextVNode(" ON A MISSION"),
                                  _hoisted_12,
                                  _createElementVNode("span", null, _toDisplayString(getCountryName.value), 1)
                                ])
                              ], 2))
                            : _createCommentVNode("", true),
                          (qualificationFunction('showEditPassword'))
                            ? (_openBlock(), _createBlock(EditPassword, { key: 2 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(IconButtons)
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})